module.exports = __webpack_public_path__ + "img/sos-sq.564ddffc.svg";